import React from 'react';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className = '', ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={`block text-xs text-fieldiq-muted mb-1 font-medium ${className}`}
        {...props}
      />
    );
  }
);
Label.displayName = 'Label';
